import React, { Component } from 'react';
import InlineError from './InlineError';
import PopupError from './PopupError';

const BaseError = function(props) {
    let error = props.error;
    if(error.directive === 'REFRESH') {
        document.location.reload();
    }
    if(error.redirect_link) {
        document.location = error.redirect_link;
    }
    if(props.popup) {
        return <PopupError error={error} proceedFunction={props.proceedFunction} proceedText={props.proceedText} closeFunction={props.closeFunction} closeText={props.closeText}/>;
    }else {
        return <InlineError error={error} proceedFunction={props.proceedFunction} proceedText={props.proceedText} closeFunction={props.closeFunction} closeText={props.closeText}/>;
    }
};
export default BaseError;